/**
 * 核心工具类
 */

/**
 * 工具类函数-将指定字符串转为JSON
 * 1、如果已经是JSON则直接返回；
 * 2、如果数据不是JSON格式无法转换，则原内容返回
 *
 * @param str 待转换数据
 * @returns json 转换后的 JSON 数据
 */
export function parseJson(str) {
  if (!str) {
    return str;
  }

  if (typeof str === 'object') {
    return str;
  }

  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}
